import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef, useCallback, useEffect } from 'react';
import { i as incrementOption, d as decrementOption, c as clearOption, j as jumpToOption } from './spinnerNavigation-BdO3lpWM.js';
import { T as Text } from '../../../Text/Text-CMA5aND3.js';
import { n as noop } from '../../../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const SpinnerInput = ({
  id,
  className = '',
  value,
  nullDisplayOption = '--',
  options,
  onChange,
  size = 2,
  isFocus,
  focusNext = noop,
  focusPrevious = noop,
  label = '',
  ...rest
}) => {
  const inputRef = useRef(null);
  const inputBuffer = useRef('');
  const setInputSelected = useCallback(() => {
    if (typeof window !== 'undefined' && inputRef.current) {
      var _inputRef$current2;
      if (document.activeElement !== inputRef.current) {
        var _inputRef$current;
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
      }
      (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.setSelectionRange(0, size);
    }
  }, [inputRef, size]);

  // reset buffer on isFocus change
  useEffect(() => {
    if (isFocus) {
      inputBuffer.current = '';
    }
  }, [isFocus]);

  // set focus on isFocus change or value change
  useEffect(() => {
    if (isFocus) {
      setInputSelected();
    }
  }, [value, isFocus, setInputSelected]);
  const onKeyDown = event => {
    const {
      key
    } = event;

    // We do not override Tab input, keep native functionality.
    if (key === 'Tab') {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    if (key === 'ArrowUp') {
      onChange(incrementOption(options, value));
      return;
    }
    if (key === 'ArrowDown') {
      onChange(decrementOption(options, value));
      return;
    }
    if (key === 'Backspace') {
      onChange(clearOption());
      inputBuffer.current = '';
      return;
    }
    if (key === 'ArrowRight') {
      focusNext === null || focusNext === void 0 || focusNext(event);
      return;
    }
    if (key === 'ArrowLeft') {
      focusPrevious === null || focusPrevious === void 0 || focusPrevious(event);
      return;
    }
    const {
      matchType,
      foundOption,
      updatedBuffer
    } = jumpToOption(options, key, size, inputBuffer.current);
    if (matchType === 'preliminary' || matchType === 'full') {
      inputBuffer.current = updatedBuffer;
      onChange(foundOption);
      if (matchType === 'full') {
        focusNext === null || focusNext === void 0 || focusNext(event);
      }
    }
  };
  const onClick = () => {
    if (isFocus) {
      setInputSelected();
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id
  }, /*#__PURE__*/React__default.createElement(Text, {
    srOnly: true
  }, label)), /*#__PURE__*/React__default.createElement("input", _extends({
    id: id
  }, rest, {
    size: size,
    ref: inputRef,
    className: className,
    type: "text",
    value: value !== null && value !== void 0 ? value : nullDisplayOption,
    onKeyDown: onKeyDown,
    onClick: onClick,
    readOnly: true
  })));
};

export { SpinnerInput as S };
//# sourceMappingURL=SpinnerInput-DUxC1Tnv.js.map
